import React from 'react';

function SettingsLoader({ children }: SettingsLoaderProps) {
  return <>{children}</>;
}

// Add this line to export SettingsLoader as default
export default SettingsLoader;
